import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

// Component
import Header from "./Header";
import UpdateProfileContainer from "../../UpdateProfile/UpdateProfileContainer";
import ChangePasswordContainer from "../../ChangePassword/ChangePasswordContainer";
import  toastr  from 'COMPONENTS/ShowTostr/ShowTostr';

//Utility
import { getMessage } from "CONFIG/i18n";
import { CONFIG } from "UTILS/Constants";
import { USER_ROLES } from "UTILS/Constants";
import { getSSOLogoutUrl } from "UTILS/Utility";

// Selectors
import { selectUserName, selectCustomerId } from "../../MainLayout/selectors";
import { selectUserRole } from "../../Whiteboard/selectors";
import { getModules,getHeaderIcons, selectAllowedDownloads,
  getIsOrganizer, getSubLoggingLevels, getLoggingLevel,
  getSSODetails, getStorageDetails, isDownloadModuleSelected,
  getIsSSOEnabled, getIsSystemPassword, getURIIdentifier,
  getIsPasscodeEnabled, getLastLoginDate
} from "../../CommonComponents/Header/selectors";

// Constants
import { ERROR } from "UTILS/Constants";

//actions
import { organisationAction, userProfileAction, logoutAction, userAction } from "CONFIG/ActionFactory";

class HeaderContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isSuperAdmin: false,
      showUserProfileModal: false,
      userProfileData: {},
      showChangePasswordModal: false,
    };
  }

  componentDidMount() {
    this.getUserProfile(this.props.isSystemPassword);
    if(this.props.isSystemPassword){
      this.toggleChangePasswordModal();
    }
  }

  getUserProfile = () => {
    userProfileAction.getUserProfileAction().then(
      respone => {
        this.setState({ userProfileData: respone.data.data });
      },
      error => {}
    );
  };

  handleLogoutClick = () => {
    let uriIdentifier ="";
    if(this.props.uriIdentifier){
      uriIdentifier = "/" + this.props.uriIdentifier;
    }
    if (this.props.isSSOLogin) {
      let ssoLogoutUrl = getSSOLogoutUrl(this.props.ssoDetails, uriIdentifier);
      window.location.assign(ssoLogoutUrl);
    } else {
      logoutAction.logoutAction().then(
        data => {
          organisationAction.setLogoUrl(null);
          userAction.saveSessionListCurrentPageNo(0);
          userAction.saveUserListCurrentPageNo(0);
          organisationAction.saveCurrentActiveTab("1");
          this.props.history.push(CONFIG.path.logout)
        },
        error => {
          if(error.code !== ERROR.NOT_AUTHORIZED)
            toastr.error(getMessage(error.code));
        }
      );
    }
  };

  handleUpdateProfileClick = () => {
    this.setState({ showUserProfileModal: !this.state.showUserProfileModal });
  };

  verifyStorage=(storageElement,callback)=>{
    organisationAction.verifyStorage(storageElement).then(
      data => {
        callback && callback();
      }
    ).catch (
      error => {
        callback && callback(error);
      }
    )
  }
  updateCustomerSettings = (details, callback)=>{
    organisationAction.updateCustomerSettings(this.props.customerId, details).then(
      data => { organisationAction.getCustomersAction(this.props.customerId).then(
        responseObject => {
          callback && callback();
          toastr.success(getMessage("SETTINGS_SAVED"));
        });
      }
    ).catch (
      error => {
        if(error.code !== ERROR.NOT_AUTHORIZED)
          toastr.error(getMessage(error.code));
        callback && callback(error);
      }
    )
  }
  toggleChangePasswordModal = () => {
    this.setState({ showChangePasswordModal: ! this.state.showChangePasswordModal });
  }

  gotoAdminSettings=()=>{
    this.props.history.push(CONFIG.path.adminSettings);
  }

  gotoAddOrganization=()=>{
    this.props.history.push(CONFIG.path.addOrganization);
  }

  render() {
    return (
      <>
        <Header
          title={this.props.title}
          headerButtonText={this.props.headerButtonText}
          showAddUserModal={this.props.showAddUserModal}
          handleLogoutClick={this.handleLogoutClick}
          showAboutOrgModal={this.props.showAboutOrgModal}
          showAddUserDropdown={this.props.showAddUserDropdown}
          isSuperAdmin={this.props.role === USER_ROLES.SUPER_ADMIN}
          isAdmin ={this.props.role===USER_ROLES.ADMIN}
          handleUpdateProfileClick={this.handleUpdateProfileClick}
          username={this.props.userName}
          userProfileData={this.state.userProfileData}
          showQRPopUp={this.props.showQRPopUp}
          logoUrl={this.props.logoUrl}
          showQR={this.props.showQR}
          showSettingsOption = {this.props.role === USER_ROLES.ADMIN && this.props.isDashboard}
          isDashboard={this.props.isDashboard}
          allowedDownloads={this.props.allowedDownloads}
          availableSubLoggingLevels={this.props.availableSubLoggingLevels}
          loggingLevel={this.props.loggingLevel}
          storageDetails={this.props.storageDetails}
          SSODetails={this.props.ssoDetails}
          isOrganizer={this.props.isOrganizer}
          toggleChangePasswordModal={this.toggleChangePasswordModal}
          showChangePasswordModal={this.state.showChangePasswordModal}
          role={this.props.role}
          updateCustomerSettings={this.updateCustomerSettings}
          verifyStorage={this.verifyStorage}
          isDownloadModuleSelected={this.props.isDownloadModuleSelected}
          modules={this.props.modules}
          isSSOEnabled={this.props.isSSOEnabled}
          handleSearchString={this.props.handleSearchString}
          onCancelButton={this.props.onCancelButton}
          uriIdentifier={this.props.uriIdentifier}
          isPasscodeEnabled={this.props.isPasscodeEnabled}
          gotoAdminSettings={this.gotoAdminSettings}
          gotoAddOrganization={this.props.gotoAddOrganization}
          isSSOLogin={this.props.isSSOLogin}
          language={this.props.language}
          lastLoginDate={this.props.lastLoginDate}
          gotoSupportCenter={this.props.gotoSupportCenter}
        />
        <UpdateProfileContainer
          show={this.state.showUserProfileModal}
          toggle={this.handleUpdateProfileClick}
          getAllUserData={this.props.getAllUserData}
          getUserProfile={this.getUserProfile}
          userRole={this.props.role}
          userProfileData={this.state.userProfileData}
        />
        <ChangePasswordContainer
          show={this.state.showChangePasswordModal}
          toggleModal={this.toggleChangePasswordModal}
          isSystemPassword= {this.props.isSystemPassword}
          language={this.props.language}
        />
      </>
    );
  }
}

const mapStateToProps = state => {
  return {
    userName: selectUserName(state),
    role: selectUserRole(state),
    customerId: selectCustomerId(state),
    modules: getModules(state),
    allowedDownloads: selectAllowedDownloads(state),
    isOrganizer: getIsOrganizer(state),
    availableSubLoggingLevels: getSubLoggingLevels(state),
    loggingLevel: getLoggingLevel(state),
    storageDetails: getStorageDetails(state),
    ssoDetails:getSSODetails(state),
    isDownloadModuleSelected: isDownloadModuleSelected(state),
    headerIcons: getHeaderIcons(state),
    isSSOEnabled: getIsSSOEnabled(state),
    uriIdentifier: getURIIdentifier(state),
    isPasscodeEnabled: getIsPasscodeEnabled(state),
    isSystemPassword: getIsSystemPassword(state),
    isSSOLogin: state.UserReducer.userDetails.isSSOLogin,
    language: state.LanguageReducer.language,
    lastLoginDate: getLastLoginDate(state),
  };
};

const mapDispatchToProps = dispatch => {
  return bindActionCreators({}, dispatch);
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(HeaderContainer);
